import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions"
const mapStateToProps = (state) => {
    return {
        portfolioChart: state.jarvisPrime.primeDashboard.portfolioChart
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPortfolioChartAction: jarvisPrimeDashboardActions.getPortfolioChart, 
}, dispatch)

const PerformanceChartStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default PerformanceChartStore;